import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormatSettings } from '@progress/kendo-angular-dateinputs';
import { DialogService } from '@progress/kendo-angular-dialog';
import { NotificationService } from '@progress/kendo-angular-notification';
import { SVGIcon, xIcon } from '@progress/kendo-svg-icons';
import _ from 'lodash';
import moment from 'moment';
import {
  Observable,
  combineLatest,
  filter,
  startWith,
  take,
  takeUntil,
} from 'rxjs';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { EvaluationService } from 'src/app/modules/evaluations/services/evaluation.service';
import { LoadingService } from 'src/app/services/loading.service';
import { RoutesConstantService } from 'src/app/services/routes-constant.service';
import { AuthStore } from 'src/app/stores/auth.store';
import { ReferenceStore } from 'src/app/stores/reference.store';
import { reviewAction } from '../../constants/form-controls';
import {
  ACTION_TYPE_APPROVED,
  ACTION_TYPE_FINALIZED,
  ACTION_TYPE_REJECTED,
  ACTION_TYPE_REQUESTED,
  APPROVE,
  ASSTMT_REJECTION_REASON_ID,
  EXTENSION_DATA_ACCEPTED_STATUS,
  EXTENSION_DATA_CLOSED_STATUS,
  EXTENSION_DATA_NOT_SUBMITTED_STATUS,
  EXTENSION_DATA_REJECTED_STATUS,
  PATH_DATA_INDEX,
  REASON_FOR_EXTENSION_OTHER,
  REJECT,
  REQUEST_EXTENSION,
  REVIEW,
  REVIEW_ASSESSMENT,
  VIEW,
  VIEW_ASSESSMENT,
} from '../../constants/request-extension';
import { IReferenceData } from '../../interfaces/form/reference-data.model';
import { ISedmsFormModel } from '../../interfaces/form/sedms-form-model';
import { AddRequestExtensionFormModel } from '../../models/request-extension/request-extension-formmodel';
import { RequestExtensionModel } from '../../models/request-extension/request-extension-request-model';
import { SubmitRequestExtensionModel } from '../../models/request-extension/submit-request-extension-model';
import { User } from '../../models/user';
import { AbstractForm } from '../abstract-form';
import { ReferenceValueResponse } from 'src/app/modules/evaluations/interfaces/reason-for-delay';
import { CaseActionStatusId } from '../../enums/case-action-status';

@Component({
  selector: 'app-request-extension',
  templateUrl: './request-extension.component.html',
  styleUrls: ['./request-extension.component.scss'],
  standalone: false,
})
export class RequestExtensionComponent extends AbstractForm<
  RequestExtensionModel,
  RequestExtensionModel,
  Record<string, IReferenceData[]>
> {
  form: FormGroup;
  formModel: ISedmsFormModel = AddRequestExtensionFormModel;
  selectedAction: string | null = null;
  loading: boolean = false;
  date: Date = new Date();
  @Output() closeDialog: EventEmitter<void> = new EventEmitter<void>();
  @Input() evaluationSk: string;
  @Input() evaluationName: string;
  @Input() referralSk: string;
  @Input() action: string;
  @Input() dueDate: string;
  @Input() createExtension: boolean;
  @Input() assessmentName: string;
  @Output() extensionCreated = new EventEmitter<{
    requestedOn: string;
    requestedBy: string;
    requestedByRole: string;
  }>();
  showApproveOrRejectBtn: boolean = false;
  user: User;
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  assessmentDetails: any;
  showApproveFields: boolean;
  showExtensionDaysError: boolean;
  showRejectFields: boolean;
  showHideCloseBtn: boolean = true;
  isApprovedAction: string;
  showAddInformation: boolean;
  showRejectedAddInformation: boolean;
  tile: string;
  title: string;
  showReviewAssessment: boolean;
  showReviewAssementReject: boolean;
  showAssessmentRejectedAddInformation: boolean;
  showSubmitBtn: boolean;
  showrewAssessment: string;

  // extensionDaysRange:IReferenceData[];
  extensionDaysRange: any;
  reviewSubmittedDisplayName: string = '';
  reviewAction: string = reviewAction;
  public format: FormatSettings = {
    displayFormat: 'MM/dd/yyyy',
    inputFormat: 'MM/dd/yyyy',
  };
  view: string = VIEW;
  reject: string = REJECT;
  assessmentRejectionId: number = ASSTMT_REJECTION_REASON_ID;
  viewAssessment: string = VIEW_ASSESSMENT;
  isStatusFinalised: boolean;
  xIcon: SVGIcon = xIcon;

  constructor(
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private readonly routesConstantService: RoutesConstantService,
    private evaluationService: EvaluationService<SubmitRequestExtensionModel>,
    private referenceStore: ReferenceStore,
    private authStore: AuthStore,
    public dashboardService: DashboardService,
    notificationService: NotificationService,
    dialogService: DialogService,
    cdRef: ChangeDetectorRef,
    route: ActivatedRoute,
    formBuilder: FormBuilder,
    loadingService: LoadingService
  ) {
    super(
      loadingService,
      cdRef,
      route,
      formBuilder,
      dialogService,
      notificationService
    );

    this.getAllApis();
    this.extensionDaysRange = Array.from(
      { length: 30 },
      (_: unknown, i: number) => i + PATH_DATA_INDEX
    );
    this.loading = true;
  }

  /////////////////
  get entity$(): Observable<RequestExtensionModel> {
    return this.evaluationService.getEvalutions(
      this.evaluationSk,
      'Evaluations'
    );
  }

  // For Getting Data from Dropdown
  get referenceData$(): Observable<IReferenceData[][]> {
    return combineLatest([
      this.referenceStore.extReq$,
      this.referenceStore.assessmentRejection$,
    ]);
  }

  override readonly isDialog: boolean = true;

  //get dropdown details data and entity get by Id Data
  initEntity(
    entityData: unknown,
    referenceData: Record<string, IReferenceData[]>
  ): RequestExtensionModel {
    return new RequestExtensionModel(entityData, referenceData);
  }

  getAllApis(): void {
    this.authStore.UserInfo$.pipe(
      filter((user: User) => !!user),
       
      take(1)
    ).subscribe((user: User) => {
      this.user = user;
      setTimeout(() => {
        this.cdRef.detectChanges();
      });
    });
  }

  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  initReferenceData([reason, assessmentRejection]: [
    IReferenceData[],
    IReferenceData[]
  ]): any {
    let updatedReasonList: IReferenceData[] = [...reason];
    if (this.action === REVIEW_ASSESSMENT || this.action === VIEW_ASSESSMENT) {
      updatedReasonList = [...assessmentRejection];
    }
    return {
      reason: updatedReasonList,
    };
  }

  public override afterOnDestroy(): void {
    // afterOnDestroy
  }

  initWatches(): void {
    this.assessmentDetails = this.entityData;
    if (this.action === 'ViewManadates') {
      this.form.disable();
    }
    this.isStatusFinalised = [
      CaseActionStatusId.Finalized,
      CaseActionStatusId.STACSubmitted,
      CaseActionStatusId.STACApproved,
    ].includes(this.assessmentDetails?.actionStatus);
    if (this.assessmentDetails?.reviewAssessment !== null) {
      // Dev: Check if newDueByDate is not empty, then Check if the dueDate is empty (covers null, undefined, and empty string).
      // If it's not empty, convert it to a localized date string; otherwise, set dueDate to an empty string.
      if (!_.isEmpty(this.assessmentDetails?.DueDate)) {
        const _iDate: Date = new Date(this.assessmentDetails?.DueDate);
        this.dueDate = _iDate.toLocaleDateString();
      } else if (_.isEmpty(this.assessmentDetails?.reviewAssessment?.dueDate)) {
        this.dueDate = '';
      } else {
        const _iDate: Date = new Date(
          this.assessmentDetails?.reviewAssessment?.dueDate
        );
        this.dueDate = _iDate.toLocaleDateString();
      }
    }
    if (this.action === REVIEW) {
      this.showAndHideApproveOrRejectData();
      this.form.get('extensionDays').disable();
      this.form.get('reviewDate').disable();
      this.form.get('reason').disable();
      this.form.get('otherReason').disable();
      this.form.get('extensionDaysApproved').enable();
      this.form.get('newDueByDate').enable();
      this.form.get('reasonForRejection').enable();
      this.form.get('otherReasonForRejection').enable();
      const extensionDaysNeeded = this.form.get('extensionDays')?.value;
      this.form.get('extensionDaysApproved').setValue(extensionDaysNeeded);
    } else if (this.action === 'view' || this.action === VIEW) {
      this.title = 'View Request for Extension';
      this.form.disable();
      this.showSubmitBtn = false;
      this.showApproveOrRejectBtn = false;
      this.showHideCloseBtn = true;
      this.showApproveFields = false;
      this.showReviewAssementReject = false;
      this.showReviewAssessment = false;
      this.showAndHideApproveOrRejectData();
      this.showSubmitBtn = true;
      this.showAndHideApproveOrRejectData();
    } else if (this.action === REVIEW_ASSESSMENT) {
      this.title = 'Review Assessment';

      this.showrewAssessment = this.action;
      this.evaluationName =
        this.assessmentDetails?.reviewAssessment?.evalutionName;

      this.form.get('asstmtRejectionReason').enable();
      this.form.get('asstmtRejectionReasonOther').enable();
      this.showHideCloseBtn = true;
      this.showApproveOrRejectBtn = true;
      this.showReviewAssessment = true;
      this.reviewSubmittedDisplayName = `${this?.user?.firstName} ${this?.user?.lastName}`;
      if (this.assessmentDetails?.reviewAssessment?.asstmtReviewApproved) {
        this.selectedAction = APPROVE;
        this.isApprovedAction = APPROVE;
      } else if (
        this.assessmentDetails?.reviewAssessment?.asstmtRejectionReasonOther ||
        this.assessmentDetails.reviewAssessment?.asstmtRejectionReason
      ) {
        this.selectedAction = REJECT;
        this.isApprovedAction = REJECT;
        this.showReviewAssementReject = true;
        this.showApproveFields = false;
        this.showReviewAssessment = true;
      }
    } else if (this.action === VIEW_ASSESSMENT) {
      this.title = 'View Assessment';
      this.showrewAssessment = this.action;
      this.showHideCloseBtn = true;
      this.showSubmitBtn = true;
      this.showApproveOrRejectBtn = true;
      this.showReviewAssessment = true;
      this.showApproveFields = false;
      this.showReviewAssessment = true;
      this.reviewSubmittedDisplayName = this.entity?.submittedBy;
      this.form.get('asstmtRejectionReason').disable();
      this.form.get('asstmtRejectionReasonOther').disable();
      if (this.assessmentDetails?.reviewAssessment.asstmtReviewApproved) {
        this.selectedAction = APPROVE;
      } else if (
        this.assessmentDetails.reviewAssessment?.asstmtRejectionReasonOther ||
        this.assessmentDetails.reviewAssessment?.asstmtRejectionReason
      ) {
        this.selectedAction = REJECT;
      }
    } else {
      // User is creating a request for extension
      this.showHideCloseBtn = false;
      this.title = REQUEST_EXTENSION;
      this.form.get('reason').setValidators([Validators.required]);
      this.form.get('reason').updateValueAndValidity();
    }
    this.form
      .get('extensionDays')
      ?.valueChanges.pipe(
        takeUntil(this.componentDestroyed),
        startWith(this.form.get('extensionDays')?.value)
      )
      .subscribe(() => {
        this.showExtensionDaysError = false;
      });

    this.form
      .get('reason')
      ?.valueChanges.pipe(
        takeUntil(this.componentDestroyed),
        startWith(this.form.get('reason')?.value)
      )
      .subscribe((value: ReferenceValueResponse) => {
        if (value?.id === REASON_FOR_EXTENSION_OTHER) {
          this.showAddInformation = true;
          this.form.get('otherReason').setValidators([Validators.required]);
          this.form.get('otherReason').updateValueAndValidity();
        } else {
          this.showAddInformation = false;
          this.form.get('otherReason').setValidators([]);
          this.form.get('otherReason').updateValueAndValidity();
        }
      });

    this.form
      .get('reasonForRejection')
      ?.valueChanges.pipe(
        takeUntil(this.componentDestroyed),
        startWith(this.form.get('reasonForRejection')?.value)
      )
      .subscribe((value: any) => {
        if (value?.id === 6) {
          this.showRejectedAddInformation = true;
          this.form
            .get('otherReasonForRejection')
            .setValidators([Validators.required]);
          this.form.get('otherReasonForRejection').updateValueAndValidity();
        } else {
          this.showRejectedAddInformation = false;
          this.form.get('otherReasonForRejection').setValidators([]);
          this.form.get('otherReasonForRejection').updateValueAndValidity();
        }
        this.cdRef.markForCheck();
      });

    this.form
      .get('asstmtRejectionReason')
      ?.valueChanges.pipe(
        takeUntil(this.componentDestroyed),
        startWith(this.form.get('asstmtRejectionReason')?.value)
      )
      .subscribe((value: ReferenceValueResponse) => {
        if (value?.id === ASSTMT_REJECTION_REASON_ID) {
          this.showAssessmentRejectedAddInformation = true;
          this.form
            .get('asstmtRejectionReasonOther')
            .setValidators([Validators.required]);
          this.form.get('asstmtRejectionReasonOther').updateValueAndValidity();
        } else {
          this.showAssessmentRejectedAddInformation = false;
          this.form.get('asstmtRejectionReasonOther').setValidators([]);
          this.form.get('asstmtRejectionReasonOther').updateValueAndValidity();
        }
        this.cdRef.markForCheck();
      });

    if (this.assessmentDetails.DueDate) {
      this.form
        .get('reviewDate')
        .setValue(new Date(this.assessmentDetails.DueDate));
    }

    this.form
      .get('extensionDays')
      ?.valueChanges.pipe(
        takeUntil(this.componentDestroyed),
        startWith(this.form.get('extensionDays')?.value)
      )
      // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
      .subscribe((value: any) => {
        // TODO: Not sure whether number or string datatype for selectedId. Define and use a proper datatype instead of any
        const selectedId = value?.id || value;

        if (selectedId !== null && selectedId !== undefined) {
          let newDate: Date;
          if (this.dueDate) {
            newDate = moment(this.dueDate).add(selectedId, 'days').toDate();
          } else {
            newDate = moment().add(selectedId, 'days').toDate();
          }
          this.form.get('reviewDate').setValue(newDate);
        }
      });

    this.form
      .get('extensionDaysApproved')
      ?.valueChanges.pipe(
        takeUntil(this.componentDestroyed),
        startWith(this.form.get('extensionDaysApproved')?.value)
      )
      // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
      .subscribe((value: any) => {
        if (value) {
          let newDate: Date;
          if (this.dueDate) {
            newDate = moment(new Date(this.dueDate))
              .add(value, 'days')
              .toDate();
          } else {
            const DATE: moment.Moment = moment(new Date());
            newDate = moment(DATE.add(value, 'days')).toDate();
          }
          this.form.get('newDueByDate').setValue(newDate);
        }
      });
    this.loading = false;
  }

  onCancelSHM(): void {
    this.closeDialog.emit();
  }

  showAndHideApproveOrRejectData(): void {
    this.dueDate = this.entityData.dueDate;
    this.title = `${this.action === 'view' ? 'View' : 'Review'
      } Request for Extension`;
    this.showApproveOrRejectBtn = true;
    this.showHideCloseBtn = true;
    this.evaluationName =
      this.assessmentDetails?.reviewAssessment?.evalutionName;
    if (this.assessmentDetails?.reviewAssessment?.dueDate) {
      this.dueDate = new Date(
        this.assessmentDetails?.reviewAssessment?.dueDate
      ).toLocaleDateString();
    }

    if (
      this.assessmentDetails.reviewAssessment?.extensionDaysApproved ||
      this.assessmentDetails.reviewAssessment?.newDueByDate
    ) {
      this.showApproveFields = true;
      this.isApprovedAction = APPROVE;
      this.selectedAction = APPROVE;
    }
    if (
      this.assessmentDetails.reviewAssessment?.reasonForRejection ||
      this.assessmentDetails.reviewAssessment?.otherReasonForRejection
    ) {
      this.showRejectFields = true;
      this.isApprovedAction = REJECT;
      this.selectedAction = REJECT;
    }
  }

  postCancelConfirmation(): void {
    this.loading = false;
  }

  postSubmitConfirmation(isSubmit: boolean): void {
    if (isSubmit) {
      this.loading = false;
      if (this.action === REQUEST_EXTENSION || this.createExtension) {
        this.extensionCreated.emit({
          requestedOn: new Date().toLocaleDateString(),
          requestedBy: `${this.user.firstName} ${this.user.lastName}`,
          requestedByRole: this.user.displayName,
        });
      }
      if (this.action === REVIEW) {
        this.router.navigate([this.routesConstantService.routes.dashboard]);
      }
      if (this.action === REVIEW_ASSESSMENT) {
        this.router.navigate([this.routesConstantService.routes.dashboard]);
      } else if (this.action === VIEW_ASSESSMENT) {
        this.router.navigate([this.routesConstantService.routes.dashboard]);
      } else {
        this.closeDialog.emit();
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate([this.routesConstantService.routes.dashboard]);
          });
      }
      this.dashboardService.getReloadGridDetails(true);
    }
  }

  saveDetails(): Observable<{ isRequestSucessful?: boolean }> {
    this.loading = true;
    if (!this.form.valid) {
      this.showExtensionDaysError = true;
      return null;
    }
    // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
    let data: any;
    if (this.action !== REVIEW_ASSESSMENT) {
      data = this.form.getRawValue();
    } else {
      data = { ...this.assessmentDetails.reviewAssessment };
    }
    const extensionData: SubmitRequestExtensionModel =
      new SubmitRequestExtensionModel({ ...data });
    extensionData.evaluationSk = this.evaluationSk;
    if (this.evaluationName || this.dueDate) {
      extensionData.evalutionName = this.evaluationName;
      extensionData.dueDate = this.dueDate;
    }
    if (this.isApprovedAction === APPROVE) {
      if (this.action === REVIEW) {
        //extision
        extensionData.isApproved = true;
        extensionData.status = EXTENSION_DATA_REJECTED_STATUS;
        extensionData.actionType = ACTION_TYPE_APPROVED;
      } else {
        //Assessment
        extensionData.asstmtReviewApproved = true;
        extensionData.asstmtReviewBy = this.user.username;
        extensionData.asstmtReviewDate = new Date();
        extensionData.nycId =
          this.activatedRoute.snapshot.paramMap.get('nycId');
        extensionData.status = EXTENSION_DATA_NOT_SUBMITTED_STATUS;
        extensionData.actionType = ACTION_TYPE_FINALIZED;
      }
    } else if (this.isApprovedAction === REJECT) {
      if (this.action === REVIEW) {
        //extision
        extensionData.isApproved = false;
        extensionData.status = EXTENSION_DATA_CLOSED_STATUS;
      } else {
        //Assessment
        extensionData.asstmtReviewApproved = false;
        extensionData.asstmtReviewBy = this.user.username;
        extensionData.asstmtReviewDate = new Date();
        extensionData.asstmtRejectionReason = this.form.get(
          'asstmtRejectionReason'
        ).value.id;
        extensionData.asstmtRejectionReasonOther = this.form.get(
          'asstmtRejectionReasonOther'
        ).value;
        extensionData.status = EXTENSION_DATA_ACCEPTED_STATUS;
      }
      extensionData.actionType = ACTION_TYPE_REJECTED;
    } else extensionData.actionType = ACTION_TYPE_REQUESTED; //Create Extension Request Action Type

    return this.evaluationService.submitExtensionRequest(extensionData) as unknown as Observable<{ isRequestSucessful?: boolean }>;
  }

  get canSaveDraft(): boolean {
    return !this.form.valid;
  }

  readonly canSubmit: boolean = false;

  getAction(name: string): void {
    this.isApprovedAction = name;
    if (this.action === REVIEW) {
      if (name === APPROVE) {
        this.selectedAction = name;
        this.showApproveFields = true;
        this.showRejectFields = false;
        this.form.get('reasonForRejection').reset();
        this.form.get('otherReasonForRejection').reset();
        this.form.get('reasonForRejection').setValidators([]);
        if (!this.showReviewAssessment) {
          this.form
            .get('extensionDaysApproved')
            .setValidators([Validators.required]);
          this.form.get('extensionDaysApproved').updateValueAndValidity();
        }
      } else {
        this.form.get('extensionDaysApproved').reset();
        this.form.get('newDueByDate').reset();
        this.selectedAction = name;
        this.showRejectFields = true;
        this.showApproveFields = false;
        this.form
          .get('reasonForRejection')
          .setValidators([Validators.required]);
        this.form.get('extensionDaysApproved').setValidators([]);
        this.form.get('extensionDaysApproved').updateValueAndValidity();
      }
      this.form.get('reasonForRejection').updateValueAndValidity();
    } else if (
      this.action === 'reviewassessment' ||
      this.action === 'viewassessment'
    ) {
      if (name === 'Approve') {
        this.selectedAction = name;
        this.showApproveFields = false;
        this.showRejectFields = false;
        this.showReviewAssementReject = false;
        this.form.get('asstmtRejectionReason').reset();
        this.form.get('asstmtRejectionReasonOther').reset();
        this.form.get('asstmtRejectionReason').setValidators([]);
      } else {
        this.selectedAction = name;
        this.showRejectFields = false;
        this.showReviewAssementReject = true;
        this.showApproveFields = false;

        this.showReviewAssessment = true;
        this.form
          .get('asstmtRejectionReason')
          .setValidators([Validators.required]);
      }
      this.form.get('asstmtRejectionReason').updateValueAndValidity();
    }
  }
}
